import { useResizeObserver } from '@folklore/hooks';
import { RefObject } from 'react';

function useElementSize<T extends HTMLElement = HTMLElement>(opts = {}) {
    const {
        ref,
        entry: { contentRect = null },
    } = useResizeObserver(opts);
    const { width, height } = contentRect || {};
    return {
        ref: ref as RefObject<T>,
        width,
        height,
    };
}

export default useElementSize;
